// extracted by mini-css-extract-plugin
export var animationContainer = "_ji-0";
export var footer = "_ji-1";
export var gray = "_ji-2";
export var lineItem = "_ji-3";
export var lineItemImage = "_ji-4";
export var lineItemInfo = "_ji-5";
export var lineItemText = "_ji-6";
export var lineItems = "_ji-7";
export var modalContent = "_ji-8";
export var options = "_ji-9";
export var orderName = "_ji-a";
export var refundAmount = "_ji-b";